export var MapBackgrounds;
(function (MapBackgrounds) {
    MapBackgrounds["Streets"] = "streets";
    MapBackgrounds["Satellite"] = "satellite";
    MapBackgrounds["Outdoors"] = "outdoors";
    MapBackgrounds["Dark"] = "dark";
    MapBackgrounds["OSMStandard"] = "osmStandard";
    MapBackgrounds["OSMRelief"] = "osmRelief";
    MapBackgrounds["OSMStreets"] = "osmStreets";
    MapBackgrounds["OSMStreetsRelief"] = "osmStreetsRelief";
    MapBackgrounds["OSMLightGray"] = "osmLightGray";
    MapBackgrounds["OSMDarkGray"] = "osmDarkGray";
    MapBackgrounds["ArcGISImagery"] = "arcGISImagery";
    MapBackgrounds["ArcGISImageryLabels"] = "arcGISImageryLabels";
})(MapBackgrounds || (MapBackgrounds = {}));
export var MapBackgroundsLabels;
(function (MapBackgroundsLabels) {
    MapBackgroundsLabels["Streets"] = "Streets";
    MapBackgroundsLabels["Satellite"] = "Satellite";
    MapBackgroundsLabels["Outdoors"] = "Outdoors";
    MapBackgroundsLabels["Dark"] = "Dark";
    MapBackgroundsLabels["OSMStandard"] = "OpenStreetMap Standard";
    MapBackgroundsLabels["OSMRelief"] = "OpenStreetMap Standard with Relief";
    MapBackgroundsLabels["OSMStreets"] = "OpenStreetMap Streets";
    MapBackgroundsLabels["OSMStreetsRelief"] = "OpenStreetMap Streets Relief";
    MapBackgroundsLabels["OSMLightGray"] = "OpenStreetMap Light Gray";
    MapBackgroundsLabels["OSMDarkGray"] = "OpenStreetMap Dark Gray";
    MapBackgroundsLabels["ArcGISImagery"] = "ArcGIS Imagery";
    MapBackgroundsLabels["ArcGISImageryLabels"] = "ArcGIS Imagery Labels";
})(MapBackgroundsLabels || (MapBackgroundsLabels = {}));
